// components/admin/AdminSidebar.jsx
// Mirrors KFX Sidebar.jsx structure/styling — Admin nav variant

import { useState, useRef, useEffect, useCallback } from 'react';
import { SidebarContent as KFXSidebarBase } from '../Sidebar.jsx';
import kfxLogo from '../../images/kfxlogo.png';

/* ── Admin Nav Definition ─────────────────────────────────────── */
export const ADMIN_NAV = [
  {
    id: 'overview', section: 'MAIN', label: 'Overview',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <rect x="3" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="3" width="7" height="7" rx="1"/>
        <rect x="14" y="14" width="7" height="7" rx="1"/>
        <rect x="3" y="14" width="7" height="7" rx="1"/>
      </svg>
    ),
  },
  {
    id: 'revenue', section: 'MAIN', label: 'Revenue',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
  },
  {
    id: 'usage', section: 'MAIN', label: 'Usage',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    id: 'paid', section: 'USERS', label: ' Users',
    badgeType: 'count',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    id: 'sessions', section: 'USERS', label: 'Sessions',
    badgeType: 'count',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
      </svg>
    ),
  },
  {
    id: 'locations', section: 'USERS', label: 'Locations',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
        <circle cx="12" cy="10" r="3"/>
      </svg>
    ),
  },
  {
    id: 'devices', section: 'USERS', label: 'Devices',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <rect x="5" y="2" width="14" height="20" rx="2"/>
        <line x1="12" y1="18" x2="12.01" y2="18"/>
      </svg>
    ),
  },
  {
    id: 'feedback', section: 'PROGRAMS', label: 'Feedback',
    badgeType: 'count',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
      </svg>
    ),
  },
  {
    id: 'referrals', section: 'PROGRAMS', label: 'Referrals',
    badgeType: 'new',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
      </svg>
    ),
  },
  {
    id: 'emailblast', section: 'PROGRAMS', label: 'Email Blast',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <line x1="22" y1="2" x2="11" y2="13"/>
        <polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    ),
  },
  {
    id: 'reports', section: 'ADMIN', label: 'Reports',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/>
        <line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/>
        <polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
  },
  {
    id: 'config', section: 'ADMIN', label: 'Configuration',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
      </svg>
    ),
  },
  {
    id: 'featureconfig', section: 'ADMIN', label: 'Feature Access',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
  },
  {
    id: 'health', section: 'ADMIN', label: 'Platform Health',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
  },
  {
    id: 'settings', section: 'ADMIN', label: 'Settings',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
  },
];

/* ── Badge components (same pattern as Sidebar.jsx) ─────────── */
const BadgeCount = ({ count }) => !count ? null : (
  <span style={{
    marginLeft: 'auto', flexShrink: 0,
    background: 'var(--gold)', color: 'var(--black)',
    fontSize: 9, fontWeight: 800, fontFamily: "'Inter',sans-serif",
    padding: '2px 7px', borderRadius: 10, letterSpacing: '.02em',
    animation: 'badgePop .3s cubic-bezier(.4,0,.2,1) both',
  }}>
    {count > 999 ? '999+' : count}
  </span>
);

const BadgeNew = () => (
  <span style={{
    marginLeft: 'auto', flexShrink: 0,
    fontSize: 7.5, fontWeight: 700, letterSpacing: '.1em',
    color: 'var(--gold)', fontFamily: "'Inter',sans-serif",
    background: 'linear-gradient(135deg,rgba(212,168,67,.22),rgba(212,168,67,.07))',
    border: '1px solid rgba(212,168,67,.28)',
    padding: '2px 6px', borderRadius: 4,
    position: 'relative', overflow: 'hidden',
  }}>NEW</span>
);

/* ── Nav item (same inline style pattern as Sidebar.jsx) ─────── */
const navBase = {
  display: 'flex', alignItems: 'center', gap: 10,
  padding: '8px 12px', margin: '1px 8px',
  borderRadius: 6, fontSize: 12.5, letterSpacing: '.01em',
  cursor: 'pointer', userSelect: 'none',
  border: 'none', background: 'none',
  color: 'rgba(245,240,232,.48)',
  width: 'calc(100% - 16px)', textAlign: 'left',
  transition: 'color .16s, background .16s, transform .14s',
  position: 'relative',
  fontFamily: "'Inter', sans-serif", fontWeight: 500,
  overflow: 'hidden',
};

function AdminNavItem({ item, isActive, onClick, delay, badges }) {
  const [hov, setHov] = useState(false);
  const style = {
    ...navBase,
    animationDelay: delay,
    ...(isActive
      ? { color: 'var(--gold)', background: 'linear-gradient(90deg, rgba(212,168,67,.12), rgba(212,168,67,.03))' }
      : hov ? { color: 'rgba(245,240,232,.76)', background: 'rgba(212,168,67,.04)', transform: 'translateX(2px)' }
      : {}),
  };
  return (
    <button style={style} onClick={onClick}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      {isActive && (
        <span style={{
          position: 'absolute', left: 0, top: '15%', bottom: '15%',
          width: 3, borderRadius: '0 3px 3px 0',
          background: 'linear-gradient(180deg, transparent, var(--gold), transparent)',
          boxShadow: '0 0 8px rgba(212,168,67,.55)',
        }}/>
      )}
      <span style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 28, height: 28, borderRadius: 5, flexShrink: 0,
        background: isActive ? 'rgba(212,168,67,.13)' : 'rgba(255,255,255,.04)',
        transition: 'background .16s',
      }}>
        {item.icon}
      </span>
      <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {item.label}
      </span>
      {item.badgeType === 'count' && <BadgeCount count={badges?.[item.id]}/>}
      {item.badgeType === 'new'   && <BadgeNew/>}
    </button>
  );
}

/* ── Initials helper ─────────────────────────────────────────── */
const initials = name => name ? name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0,2) : 'AD';

/* ── AdminSidebarContent ─────────────────────────────────────── */
export function AdminSidebarContent({ page, setPage, badges = {}, onClose, user, onLogout }) {
  const sections = [...new Set(ADMIN_NAV.map(n => n.section))];
  const name = user?.name || 'Admin';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, overflow: 'hidden' }}>

      {/* Logo */}
      <div className="sb-logo" style={{ flexShrink: 0 }}>
        <div style={{ width: 44, height: 44, flexShrink: 0, position: 'relative' }}>
          <img src={kfxLogo} alt="KFX" style={{ width: 44, height: 44, objectFit: 'contain', borderRadius: 6 }}/>
          <span style={{ position: 'absolute', inset: -2, border: '1px solid rgba(212,168,67,.3)', borderRadius: 8, animation: 'glowRing 3.2s ease infinite' }}/>
        </div>
        <div className="sb-brand-wrap">
          <div className="sb-brand">KFX Admin</div>
          <div className="sb-sub">Control Panel</div>
        </div>
        {onClose && (
          <button className="sb-close-btn" onClick={onClose} aria-label="Close menu">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        )}
      </div>

      {/* Nav */}
      <nav className="sb-nav">
        {sections.map((sec, si) => (
          <div key={sec} className="sb-section">
            <div className="sb-section-label">{sec}</div>
            {ADMIN_NAV.filter(n => n.section === sec).map((item, ni) => (
              <AdminNavItem
                key={item.id}
                item={item}
                isActive={page === item.id}
                onClick={() => { setPage(item.id); onClose?.(); }}
                delay={`${(si * 3 + ni) * 45}ms`}
                badges={badges}
              />
            ))}
          </div>
        ))}
      </nav>

      {/* Live indicator */}
      <div style={{ padding: '8px 20px', flexShrink: 0, borderTop: '1px solid rgba(255,255,255,.05)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', background: 'rgba(46,204,138,.05)', border: '1px solid rgba(46,204,138,.15)', borderRadius: 6 }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)', boxShadow: '0 0 6px var(--green)', animation: 'pulseDot 2s ease infinite', flexShrink: 0 }}/>
          <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.06em', color: 'var(--green)', textTransform: 'uppercase' }}>Dashboard Live</span>
        </div>
      </div>

      {/* User footer */}
      <div className="sb-user">
        <div className="sb-avatar">{initials(name)}</div>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div className="sb-user-name">{name}</div>
          <div className="sb-user-level">
            <span className="sb-level-dot"/>
            Super Admin
          </div>
        </div>
        <button className="sb-logout" onClick={onLogout} title="Logout" aria-label="Logout">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </div>
  );
}

/* ── Desktop sidebar wrapper ─────────────────────────────────── */
export function AdminSidebar({ page, setPage, badges, onLogout, user }) {
  return (
    <div className="sidebar" style={{ display: 'flex', flexDirection: 'column' }}>
      <AdminSidebarContent page={page} setPage={setPage} badges={badges} onLogout={onLogout} user={user}/>
    </div>
  );
}

/* ── Mobile sidebar ──────────────────────────────────────────── */
export function AdminMobileSidebar({ page, setPage, badges, open, onClose, onLogout, user }) {
  const sidebarRef  = useRef(null);
  const touchStartX = useRef(null);
  const onCloseRef  = useRef(onClose);
  useEffect(() => { onCloseRef.current = onClose; }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  useEffect(() => {
    const el = sidebarRef.current;
    if (!el) return;
    const onTS = e => { touchStartX.current = e.touches[0].clientX; };
    const onTE = e => {
      if (touchStartX.current === null) return;
      if (touchStartX.current - e.changedTouches[0].clientX > 55) onCloseRef.current();
      touchStartX.current = null;
    };
    el.addEventListener('touchstart', onTS, { passive: true });
    el.addEventListener('touchend',   onTE, { passive: true });
    return () => { el.removeEventListener('touchstart', onTS); el.removeEventListener('touchend', onTE); };
  }, []);

  const handleNavigate = useCallback(p => { setPage(p); onCloseRef.current(); }, [setPage]);

  return (
    <>
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, zIndex: 89,
        opacity: open ? 1 : 0, pointerEvents: open ? 'auto' : 'none',
        transition: 'opacity .25s ease',
        background: 'rgba(0,0,0,.65)',
        backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
      }}/>
      <div ref={sidebarRef} style={{
        position: 'fixed', left: 0, top: 0, bottom: 0, width: 270, zIndex: 100,
        display: 'flex', flexDirection: 'column', height: '100dvh',
        background: 'linear-gradient(180deg, #0c0c0a 0%, #080808 100%)',
        borderRight: '1px solid var(--border)', overflow: 'hidden',
        transform: open ? 'translateX(0)' : 'translateX(-100%)',
        transition: 'transform .24s cubic-bezier(.25,.46,.45,.94)',
      }}>
        <AdminSidebarContent
          page={page} setPage={handleNavigate} badges={badges}
          onClose={onClose} onLogout={onLogout} user={user}
        />
      </div>
    </>
  );
}